export default function (currency: string, calculatedOperationValues: CalculatedValues) {
  const { clpMargin, usdMargin } = calculatedOperationValues

  if (currency === "CLP") {
    return `${clpMargin} CLP`
  } else {
    return `${usdMargin} USD`
  }
}
